export default function footerColDropDown() {
	jQuery('.footer-col .widget-title').on('click', function () {
		let ele = jQuery(this).parent().hasClass('widget_nav_menu') ? jQuery(this).parent().find('ul.menu').get(0) : jQuery(this).next().get(0);
		slideUpDown(ele, jQuery(this).get(0));
	});
	jQuery('.footer-col .footer-title').on('click', function () {
		slideUpDown(jQuery(this).next().get(0), jQuery(this).get(0));
	});

	function slideUpDown(ele, toggle) {
		if (undefined === ele.dataset.open || 'false' === ele.dataset.open) {
			gsap.set(ele, {
				height: 'auto'
			});

			gsap.from(ele, {
				height: 0,
				onStart: () => {
					toggle.classList.add('open');
					ele.dataset.open = 'true';
				}
			});
		} else if ('true' === ele.dataset.open) {
			gsap.to(ele, {
				height: 0,
				onStart: () => {
					toggle.classList.remove('open');
					ele.dataset.open = 'false';
				}
			});
		}
	}
};